import React, { useEffect, useState } from 'react';
import moment from 'moment';

const Clock = () => {
  const [time, setTime] = useState(moment());
  useEffect(() => {
    const tick = () => {
      setTime(moment());
    };
    const timeInterval = setInterval(tick, 1000);
    return () => {
      clearInterval(timeInterval);
    };
  }, []);
  return (
    <h1 style={{ paddingTop: 12 }}>{time.format('HH:mm:ss')}</h1>
  );
};
export default Clock;



// WEBPACK FOOTER //
// ./src/sites/time/components/Clock.js